define('app/views/templates/helpers/fetchValue',['Handlebars','moment'], function ( Handlebars,moment ){
    function fetchValue(obj, type) {
        var categoryMap = {
            Spa: {
                ServiceName: 'Details',
                Location: 'Location',
                CustomerName: 'CustomerName',
                Equipment: 'equipment'
            },
            Hotel: {
                ServiceName: 'Location',
                Location: 'Details',
                CustomerName: 'RateDetails',
            },
            Dining: {
                ServiceName: 'Details',
                Location: 'Location',
                CustomerName: 'CustomerName',
                AreaName: 'AreaName'
            },
            Golf: {
                ServiceName: 'Details',
                Location: 'Location',
                CustomerName: 'CustomerName',
            },
            Retail: {
                ServiceName: 'Details',
            },
            SpaWait: {
                ServiceName: 'Details',
                Location: 'LocationName',
                CustomerName: 'CustomerName',
                Equipment: 'equipment'
            },
            Ski: {
                ServiceName: 'Details',
                Location: 'Location',
            },
            Club: {
                ServiceName: 'Details',

            },
            PMSPayment:{
                ServiceName: 'Details',
                Location: 'Location',
            },
            SPAPayment:{
                ServiceName: 'Details',
                Location: 'Location',
            }
        }

        return obj[categoryMap[obj.Category][type]];
        
    }
    
    Handlebars.registerHelper( 'fetchValue', fetchValue );
    return fetchValue;
});

